import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries } from "@/api/http-common";

export function callApiGetLocations(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.PAKN.SEARCH_LOCATION}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDataDanhMuc(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.PAKN.GET_DATA_DANH_MUC}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoPakn(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PAKN.TAO_PAKN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDetailPakn(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.PAKN.XEM_PAKN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetListPAKN(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.PAKN.SEARCH_YEU_CAU, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callGetLinhVucPAKN(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.PAKN.GET_LINH_VUC_PAKN}?${buildQueries(payload)}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}
